var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UMOTIF_API } from '@/routes';
import api from './instance';
const { TESTING } = UMOTIF_API;
class TestingService {
    getTimeWarpStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.get(TESTING.GET_TIME_WARP_STATUS);
            return data;
        });
    }
    putTimeWarpBlink(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield api.put(TESTING.PUT_TIME_WARP_BLINK, payload);
            return data;
        });
    }
    putTimeWarpShift(targetStudyDay) {
        return __awaiter(this, void 0, void 0, function* () {
            const { status } = yield api.put(TESTING.PUT_TIME_WARP_SHIFT, {
                target_study_day: targetStudyDay
            });
            return status === 201;
        });
    }
}
export default new TestingService();
